export enum AppRouteEnum {
  AchRefundTable = '/reports/ach-refunds',
  Auth = '/auth',
  CancelPendings = '/reports/cancel-pendings',
  CancelRewrites = '/reports/cancel-rewrites',
  ConsumerEdit = '/consumers/:id/edit',
  ConsumerProfile = '/consumers/:id',
  ConsumerWrapUp = '/consumers/:id/wrap-up',
  Consumers = '/consumers',
  ConsumerHome = '/consumers/:id/homes/:id',
  ConsumerVehicle = '/consumers/:id/vehicles/:id',
  ContractById = '/contracts/:id',
  ContractByNumber = '/contracts/by-number/:id',
  ContractFulfillmentHistory = '/contracts/:id/fulfillment-history',
  ContactConfirmation = '/contacts/confirmation',
  ContactEcommerceCallback = '/contacts/ecommerce-callback',
  ContactExternalTransfer = '/contacts/external-transfer',
  ContactLink = '/contacts/link',
  ContactPreview = '/contacts/preview',
  ContactSearchAuto = '/contacts/search/auto',
  ContactSearchMail = '/contacts/search/mail',
  ContactSearchMoxyCustomerNumber = '/contacts/search/moxy-customer-number',
  ContactWaiting = '/contacts/waiting',
  ContactWrapUp = '/contacts/:id/wrap-up',
  ContractsAdjustmentAdjustCoverage = '/contracts/:id/adjustment/adjust-coverage',
  ContractsAdjustmentAdditionalActions = '/contracts/:id/adjustment/additional-actions',
  ContractsAdjustmentConfirmAdjustment = '/contracts/:id/adjustment/confirm-adjustment',
  ContractsAdjustmentConfirmOdometer = '/contracts/:id/adjustment/confirm-odometer',
  ContractCollectDownPayment = '/contracts/:id/collect-down-payment/',
  ContractPayInFullOnSold = '/contracts/:id/pay-in-full/',
  ContractCollectExceptionPayment = '/contracts/:id/exception-payment/',
  ContractTransmittalEventsErrorReport = '/reports/contract-transmittal-events-errors',
  Dashboard = '/dashboard',
  DealLog = '/deal-log',
  PostDateDeclines = '/reports/post-date-declines',
  DuplicateSaves = '/reports/duplicate-saves',
  Forbidden = '/forbidden',
  FundedFullRefunds = '/reports/funded-full-refunds',
  // Home = '/dashboard',
  HomeQuoteFlowEntry = '/home-quotes/:id',
  HomeQuoteFlowHomeDetails = '/home-quotes/:id/home-details',
  HomeQuoteFlowSelectCoverage = '/home-quotes/:id/select-coverage',
  HomeQuoteFlowContactInfo = '/home-quotes/:id/contact-info',
  HomeQuoteFlowSecondHolder = '/home-quotes/:id/second-holder',
  HomeQuoteFlowPaymentDetails = '/home-quotes/:id/payment-details',
  HomeQuoteFlowFinalize = '/home-quotes/:id/finalize',
  HomeQuoteFlowSaleComplete = '/home-quotes/:id/sold',
  HomeQuoteFlowWrapUp = '/home-quotes/:id/wrap-up',
  HomeQuoteFlowRecap = '/home-quotes/:id/recap',
  HomeQuoteFlowTransferCall = '/home-quotes/:id/transfer-call',
  HomeQuoteFlowCoverageAvailability = '/home-quotes/:id/coverage-availability',
  HomeContractAdjustmentAdjustCoverage = '/home-contracts/:id/adjustment/adjust-coverage',
  HomeContractWrapUp = '/home-contracts/:id/wrap-up',
  InProgressFulfillments = '/reports/in-progress-fulfillments',
  KnowledgeBase = '/knowledge-base',
  NewHomeQuote = '/home-quotes/new',
  NewQuote = '/quotes/new',
  Quotes = '/quotes',
  QuoteFlowContactInfo = '/quotes/:id/contact-info',
  QuoteFlowCoverageAvailability = '/quotes/:id/coverage-availability',
  QuoteFlowEntry = '/quotes/:id',
  QuoteFlowFinalize = '/quotes/:id/finalize',
  QuoteFlowMissingVehicleDetails = '/quotes/:id/missing-vehicle-details',
  QuoteFlowPaymentMethod = '/quotes/:id/payment-method',
  QuoteFlowPayments = '/quotes/:id/payments',
  QuoteFlowSecondHolder = '/quotes/:id/second-holder',
  QuoteFlowSelectPlan = '/quotes/:id/select-plan',
  QuoteFlowVehicleDetails = '/quotes/:id/vehicle-details',
  QuoteFlowVehicleModifications = '/quotes/:id/vehicle-modifications',
  QuoteFlowClosed = '/quotes/:id/closed',
  QuoteFlowSaleComplete = '/quotes/:id/sold',
  QuoteFlowWrapUp = '/quotes/:id/wrap-up',
  QuoteScratchpad = '/quote-scratchpad',
  SendQuote = '/quotes/:id/send-quote',
  QuoteFlowTransferCall = '/quotes/:id/transfer-call',
  QuoteFlowRecap = '/quotes/:id/recap',
  QuoteFlowEquityCalculation = '/quotes/:id/equity',
  QuoteFlowCompleteRewrite = '/quotes/:id/complete-rewrite',
  QuoteFlowConfirmRewrite = '/quotes/:id/confirm-rewrite',
  V2QuoteFlowEntry = '/v2/quotes/:id',
  V2NewQuote = '/v2/quotes/new',
  V2QuoteFlowClosed = '/v2/quotes/:id/closed',
  V2QuoteFlowCompleteRewrite = '/v2/quotes/:id/complete-rewrite',
  V2QuoteFlowConfirmRewrite = '/v2/quotes/:id/confirm-rewrite',
  V2QuoteFlowContactInfo = '/v2/quotes/:id/contact-info',
  V2QuoteFlowCoverageAvailability = '/v2/quotes/:id/coverage-availability',
  V2QuoteFlowEquity = '/v2/quotes/:id/equity',
  V2QuoteFlowFinalize = '/v2/quotes/:id/finalize',
  V2QuoteFlowMissingVehicleDetails = '/v2/quotes/:id/missing-vehicle-details',
  V2QuoteFlowPaymentMethod = '/v2/quotes/:id/payment-method',
  V2QuoteFlowPayments = '/v2/quotes/:id/payments',
  V2QuoteFlowRecap = '/v2/quotes/:id/recap',
  V2QuoteFlowSaleComplete = '/v2/quotes/:id/sold',
  V2QuoteFlowSecondHolder = '/v2/quotes/:id/second-holder',
  V2QuoteFlowSelectPlan = '/v2/quotes/:id/select-plan',
  V2QuoteFlowSendQuote = '/v2/quotes/:id/send-quote',
  V2QuoteFlowTransferCall = '/v2/quotes/:id/transfer-call',
  V2QuoteFlowVehicleDetails = '/v2/quotes/:id/vehicle-details',
  V2QuoteFlowVehicleModifications = '/v2/quotes/:id/vehicle-modifications',
  V2QuoteFlowWrapUp = '/v2/quotes/:id/wrap-up',
  Settings = '/settings',
  Users = '/users',
  PhysicalChecks = '/reports/physical-checks',
  ProcessContractManualRefund = '/contracts/:id/process-ach-refunds',
  ProcessSalePendingManualRefund = '/sale-pending/:id/process-ach-refunds',
  Roles = '/roles',
  VehicleDetails = '/vehicles/:id',
  VehicleShops = '/vehicle-shops/:id',
  Waiting = '/contacts/waiting/:id',
  CancelFlat = '/contracts/:id/cancel/flat',
  RequestCancellation = '/contracts/:id/cancel/request-cancellation',
  CompleteCancellation = '/contracts/:id/cancel/complete-cancellation',
  ProRatedRefund = '/contracts/:id/cancel/pro-rated-refund',
  CalculateProRatedRefund = '/contracts/:id/cancel/calculate-pro-rated-refund',
  RemoveCancelPending = '/contracts/:id/cancel/remove-cancel-pending',
  CancelNonPay = '/contracts/:id/cancel/non-pay',
  TransferContractUploadTransferForm = '/contracts/:id/transfer/upload-transfer-form',
  TransferContractSelectCustomer = '/contracts/:id/transfer/select-customer',
  TransferContractCollectMissingInfo = '/contracts/:id/transfer/collect-missing-info',
  TransferContractAdditionalHolder = '/contracts/:id/transfer/additional-holder',
  TransferContractPayments = '/contracts/:id/transfer/payments',
  TransferOwnerships = '/reports/transfer-ownerships-eds',
  NonEdsTransferOwnerships = '/reports/transfer-ownerships-non-eds',
  RetentionDiscounts = '/reports/retention-discounts',
  ContractWrapUp = '/contracts/:id/wrap-up',
  AdditionalRefund = '/contracts/:id/additional-refund',
  FullRefundManagerApproval = '/contracts/:id/full-refund/manager-approval',
  FullRefundCreateRequest = '/contracts/:id/full-refund/create-refund',
  FullRefundApproveRefund = '/contracts/:id/cancel/approve-full-refund',
  FullRefundIssueRefund = '/contracts/:id/cancel/issue-full-refund',
  VinAudit = '/vin-audit',
  MissingDownPayment = '/reports/missing-down-payment',
  ProRatedRefundsReport = '/reports/pro-rated-refund',
  CollectionReporting = '/contracts/:id/collection-reporting',
  CarfaxReports = '/reports/carfax/:id',
  V2ConsumerEdit = '/v2/consumers/:id/edit',
  V2ConsumerProfile = '/v2/consumers/:id',
  V2Dashboard = '/v2/dashboard',
  V2DealLog = '/v2/deal-log',
  V2Reports = '/v2/reports',
  V2Roles = '/v2/roles',
  V2Users = '/v2/users',
  V2VinAudit = '/v2/vin-audit',
}
